import * as commonScripts from '../common'

const cmpHeader = {
  component: null,
  mobileMenu: null,

  init: function (element) {
    const _ = this
    _.component = element
    _.mobileMenu = document.getElementById('menu-mobile')
    _.initMobile()
    _.initHoverState(element)
    _.onScrollEvent()
    _.initDesktopLocations(element)
    _.initDesktopSearchButton(element)
    const subMenuNav = document.querySelector('.sub-menu-navigation')
    subMenuNav.style.height = 'auto'
    //subMenuNav.style.minHeight = '0'
  },

  initMobile: function () {
    const _ = this
    _.component
      .querySelectorAll('[data-control*="toggle-mobile-menu"]')
      .forEach(function (el) {
        el.addEventListener(
          'touchstart',
          function (event) {
            event.preventDefault() // prevent the 'click' on touch screens
            _.toggleMobile(event)
          },
          false
        )
        el.addEventListener(
          'click',
          function (event) {
            _.toggleMobile(event)
          },
          false
        )
      })
    // container where menu option is displayed
    const optionSelectedContainer = _.component.querySelector(
      '.cmp-header__menu-mobile__option-selected'
    )
    function hideShowMenuInfo () {
      optionSelectedContainer.classList.toggle('d-none')
      document.querySelector('.menu-primary').classList.toggle('d-none')
      document
        .querySelector('.cmp-header__menu-mobile__location')
        .classList.toggle('d-none')
      let myAccount =  document.querySelector('.cmp-header__menu-mobile__my-account');
      if (myAccount)
      {
        myAccount.classList.toggle('d-none')
      }     
      document.querySelector('.back-button').classList.toggle('d-none')
    }

    function addListenersToOptionSelected (optionSelectedContainer) {
      optionSelectedContainer
        .querySelectorAll('.cmp-header__menu-mobile__accordion__option__toggle')
        .forEach((accordionButton, index) => {
          accordionButton.addEventListener(
            'click',
            function (event) {
              const optionContent = event.target.parentElement
              optionContent.classList.toggle('show-option')
              commonScripts.util.inheritPermalink(optionContent)
            },
            false
          )
        })
    }

    document.querySelector('.back-button').addEventListener(
      'click',
      function (event) {
        hideShowMenuInfo()
      },
      false
    )
    document
      .querySelectorAll('.menu-primary a')
      .forEach((mobileOption, index) => {
        mobileOption.addEventListener(
          'click',
          function (event) {
            hideShowMenuInfo()

            const content =
                            event.target.parentElement.querySelector(
                              '.menu-content'
                            ).innerHTML

            optionSelectedContainer.innerHTML = content

            addListenersToOptionSelected(optionSelectedContainer)
          },
          false
        )
      })

    document
      .querySelector('.cmp-header__menu-mobile__location__button')
      .addEventListener('click', function (event) {
        const content = this.parentElement.querySelector(
          '.cmp-header__menu-mobile__location__content'
        )

        hideShowMenuInfo()
        optionSelectedContainer.innerHTML = content.innerHTML

        addListenersToOptionSelected(optionSelectedContainer)

        optionSelectedContainer
          .querySelectorAll(
            '.cmp-header__menu-mobile__accordion__option__content__locations__region__name'
          )
          .forEach((regionName) => {
            regionName.addEventListener('click', function (event) {
              const region = regionName.parentElement
              regionName.classList.toggle('font-weight-bold')
              region.querySelector('.investor-type').classList.toggle('active')
              // Target parent parent in order to change border on region click
              region.parentElement.parentElement.parentElement.classList.toggle(
                'no-border'
              )
            })
          })
      })

      let myAccount =  _.component.querySelector('.cmp-header__menu-mobile__my-account__button')
      if (myAccount)
      {
        myAccount.addEventListener('click', function () {
          const link = this.querySelector('a')
          if (link !== null) {
            const href = link.getAttribute('href')
            const target = link.getAttribute('target')
  
            if (href !== null) {
              if (target !== null) {
                window.open(href)
              } else {
                window.location.href = href
              }
            }
            link.addEventListener('click', function (event) {
              event.stopPropagation()
            })
          }
        })
      }    

    // Search field events.
    const searchBtnMobile = _.component.querySelector(
      '.cmp-header__mobile .search-toggle'
    )
    const searchFieldMobile = _.component.querySelector(
      '.cmp-header__mobile__search-field'
    )

    let searchFieldCloseBtn = ''
    let formInput = ''
    if (searchFieldMobile)
    {
      searchFieldCloseBtn = searchFieldMobile.querySelector('.clear-search')
      formInput = searchFieldMobile.querySelector('.input-search')
    }
    
    let formInputPlaceholder = ''
    if (formInput)
    {
      formInputPlaceholder = formInput.getAttribute('placeholder')

      formInput.addEventListener('focus', (e) => {
        e.preventDefault()
        formInput.setAttribute('placeholder', '')
      })
  
      formInput.addEventListener('blur', (e) => {
        e.preventDefault()
        formInput.setAttribute('placeholder', formInputPlaceholder)
      })
    }       
    
    if (searchFieldMobile) {
      searchBtnMobile.addEventListener('click', function (event) {
        searchFieldMobile.classList.toggle('active')
      })
      searchFieldCloseBtn.addEventListener('click', function (event) {
        event.preventDefault()
        searchFieldMobile.classList.toggle('active')
        formInput.value = null
      })
    }
  },

  toggleMobile: function () {
    const _ = this
    _.mobileMenu.classList.toggle('show-menu')
    if (_.mobileMenu.classList.contains('show-menu')) {
      document.body.style.overflowY = 'hidden'
    } else {
      document.body.style.overflowY = 'visible'
    }
  },

  onScrollEvent: function () {
		const _ = this
		window.addEventListener('scroll', () => {
			'use strict'
      if (
        document.body.scrollTop >= 64 ||
                document.documentElement.scrollTop >= 64
      ) {
        _.component
          .querySelector('.cmp-header__desktop')
          .classList.add('scrolled')
      } else {
        const locationsContainer = _.component.querySelector(
          '.cmp-header__desktop__locations'
        )
        const searchFieldDesktop = _.component.querySelector(
          '.cmp-header__desktop__search-field'
        )
        // When scroll back to top. If locations and search field is not displayed, change the class
        if (
          !locationsContainer.classList.contains('active') &&
                    searchFieldDesktop &&
                    !searchFieldDesktop.classList.contains('active')
        ) {
          _.component
            .querySelector('.cmp-header__desktop')
            .classList.remove('scrolled')
        }
      }
    });
  },
  initHoverState: function (component) {
    const subMenuNav = component.querySelector('.sub-menu-navigation')
    function animateInnerHtml (elem, val) {
      elem.style.opacity = 0
      setTimeout(() => {
        elem.innerHTML = val
        commonScripts.util.inheritPermalink(elem)
        elem.style.opacity = 1
      }, 200)
    }
    component
      .querySelectorAll('.cmp-header__desktop .menu ul li button')
      .forEach(function (headerMenuOption) {
        headerMenuOption.addEventListener(
          'mouseover',
          function (event) {
            const locationsContainer = component.querySelector(
              '.cmp-header__desktop__locations'
            )
            locationsContainer.classList.remove('active')

            // Hide search field
            const searchFieldDesktop = component.querySelector(
              '.cmp-header__desktop__search-field'
            )
            if (searchFieldDesktop) {
              searchFieldDesktop.classList.remove('active')
              if (document.documentElement.scrollTop <= 64) {
                component
                  .querySelector('.cmp-header__desktop')
                  .classList.remove('scrolled')
              }
            }

            resetHoverState()
            headerMenuOption.classList.add('hovered')
            // show sub menu navigation
            const headerMenuOptionContainer = event.target.parentElement
            const viewport = commonScripts.util.getViewportSize()
            // console.log(headerMenuOptionContainer)

            let headerMenuOptionContent =
                            headerMenuOptionContainer.querySelector(
                              '.menu__submenu-nav-content'
                            )
            if (headerMenuOptionContent) {
              headerMenuOptionContent = headerMenuOptionContent.innerHTML
            }

            subMenuNav.classList.add('show')

            subMenuNav.innerHTML = headerMenuOptionContent

            // populate the first sub menu option content
            let subMenuNavFirstOptionContent = subMenuNav.querySelector(
              '.subMenuNavOptionContent'
            )
            if (subMenuNavFirstOptionContent) {
              subMenuNavFirstOptionContent =
                                subMenuNavFirstOptionContent.innerHTML
            }

            const subMenuNavContent =
                            subMenuNav.querySelector('.subMenuNavContent')
            if (subMenuNavContent) {
              // subMenuNavContent.innerHTML = subMenuNavFirstOptionContent
              animateInnerHtml(subMenuNavContent, subMenuNavFirstOptionContent)
              commonScripts.util.inheritPermalink(subMenuNavContent)
              if (viewport.width >= 1440) {
                //subMenuNav.style.minHeight = '275px'
                subMenuNav.style.height = 'auto'
                subMenuNav.style.paddingBottom = '2rem';
              } else {
                subMenuNav.style.minHeight = '210px'
              }
            }
            // hover state listener for each sub menu option
            component
              .querySelectorAll(
                '.menu__submenu-nav-content__sidebar-options__option button'
              )
              .forEach(function (subMenuNavOption) {
                subMenuNavOption.addEventListener(
                  'mouseover',
                  function (event) {
                    resetHoverStateSubMenu(subMenuNavOption)

                    // show sub menu option content on hover
                    let subMenuNavOptionContent = event.target.parentElement.querySelector('.subMenuNavOptionContent')

                    setTimeout(() => {
                      if (viewport.width >= 1440) {
                        subMenuNav.style.minHeight = '255px'
                      } else {
                        subMenuNav.style.minHeight = '210px'
                      }
                    }, 300)
                    if (subMenuNavOptionContent) {
                      subMenuNavOptionContent = subMenuNavOptionContent.innerHTML
                      const subMenuNavContent = subMenuNav.querySelector('.subMenuNavContent')
                      animateInnerHtml(subMenuNavContent, subMenuNavOptionContent)
                      commonScripts.util.inheritPermalink(subMenuNavContent)
                    }
                  },
                  false
                )
              })
          },
          false
        )
      })

    function resetHoverStateSubMenu (subMenuNavOption) {
      document
        .querySelectorAll(
          '.sub-menu-navigation .menu__submenu-nav-content__sidebar-options__option button'
        )
        .forEach(function (button) {
          button.classList.remove('selected')
        })
      subMenuNavOption.classList.add('selected')
    }

    // Hide all when mouse leave header area
    component.addEventListener(
      'mouseleave',
      function () {
        resetHoverState()
        const subMenuNav = document.querySelector('.sub-menu-navigation')
        subMenuNav.innerHTML = '';
				subMenuNav.classList.remove('show');
        setTimeout(function () {
          subMenuNav.style.minHeight = '0'
          subMenuNav.style.height = 'auto'
        }, 200)
      },
      false
    )
  },
  initDesktopLocations: function (component) {
    const investorTypeContainer = component.querySelector(
      '.cmp-header__desktop__locations__display-investor-type' 
    )
    component
      .querySelector('.locations-button')
      .addEventListener('click', function (event) {
        const locationsContainer = component.querySelector(
          '.cmp-header__desktop__locations'
        )
        const searchFieldDesktop = component.querySelector(
          '.cmp-header__desktop__search-field'
        )
        if (searchFieldDesktop) {
          searchFieldDesktop.classList.remove('active')
          if (document.documentElement.scrollTop <= 64) {
            component
              .querySelector('.cmp-header__desktop')
              .classList.remove('scrolled')
          }
        }

        // Show/hide Locations container
        locationsContainer.classList.toggle('active')
        handleActiveStates(component)
      })

    component
      .querySelectorAll('.cmp-header__desktop__locations__continent__region')
      .forEach((region) => {
        region.addEventListener('click', function (event) {
          // Set region selected in bold
          resetRegionsSelected()
          region.classList.add('font-weight-bold')

          const regionInvestorTypes = region.querySelector(
            '.cmp-header__desktop__locations__continent__region__investor-type'
          ).innerHTML
          investorTypeContainer.innerHTML = regionInvestorTypes
          investorTypeContainer.classList.remove('active')
          investorTypeContainer.classList.add('active')
        })
      })

    document.addEventListener('click', function (event) {
      const locationsContainer = component.querySelector(
        '.cmp-header__desktop__locations'
      )
      const locationsButton = component.querySelector('.locations-button')

      const isClickInside = locationsContainer.contains(event.target)
      const isLocationButton = locationsButton.contains(event.target)
      if (!isClickInside && !isLocationButton) {
        // Show/hide Locations container
        if (locationsContainer.classList.contains('active')) {
          locationsContainer.classList.remove('active')
          handleActiveStates(component)
        }
      }
    })

    // Handle active states on scroll and menu nav bar
    function handleActiveStates (component) {
      const investorTypeContainer = component.querySelector(
        '.cmp-header__desktop__locations__display-investor-type'
      )
      const locationsContainer = component.querySelector(
        '.cmp-header__desktop__locations'
      )
      // Hide sub menu nav and clear any hovered menu option
      const subMenuNav = document.querySelector('.sub-menu-navigation')
      subMenuNav.classList.remove('show')
      resetHoverState()

      // Set header on active state (scrolled class)
      component.querySelector('.cmp-header__desktop').classList.add('scrolled')

      // When locations container is hidding, if scrollbar is on top, remove header active class (scrolled)
      if (
        !locationsContainer.classList.contains('active') &&
                window.scrollY === 0
      ) {
        component
          .querySelector('.cmp-header__desktop')
          .classList.remove('scrolled')
      }
      // Reset selected region
      if (!locationsContainer.classList.contains('active')) {
        resetRegionsSelected()
        investorTypeContainer.classList.remove('active')
      }
    }
  },
  initDesktopSearchButton: function (component) {
    const searchBtnDesktop = component.querySelector(
      '.cmp-header__desktop .search-toggle'
    )
    const searchFieldDesktop = component.querySelector(
      '.cmp-header__desktop__search-field'
    )
    if (searchFieldDesktop) {
      searchBtnDesktop.addEventListener('click', function (event) {
        // Hide sub menu nav and clear any hovered menu option
        const subMenuNav = document.querySelector('.sub-menu-navigation')
        subMenuNav.classList.remove('show')
        resetHoverState()

        const desktopHeader = component.querySelector('.cmp-header__desktop')
        searchFieldDesktop.classList.toggle('active')
        if (document.documentElement.scrollTop <= 64) {
          desktopHeader.classList.toggle('scrolled')
        }
      })
      // Search field events.
      const searchFieldCloseBtn =
                searchFieldDesktop.querySelector('.clear-search')
      const formInput = searchFieldDesktop.querySelector('.input-search')
      const formInputPlaceholder = formInput.getAttribute('placeholder')

      formInput.addEventListener('focus', (e) => {
        e.preventDefault()
        formInput.setAttribute('placeholder', '')
      })

      formInput.addEventListener('blur', (e) => {
        e.preventDefault()
        formInput.setAttribute('placeholder', formInputPlaceholder)
      })
      searchFieldCloseBtn.addEventListener('click', function (event) {
        event.preventDefault()
        const desktopHeader = component.querySelector('.cmp-header__desktop')
        searchFieldDesktop.classList.toggle('active')
        if (document.documentElement.scrollTop <= 64) {
          desktopHeader.classList.toggle('scrolled')
        }
        formInput.value = null
      })
    }
  }
}
/* remove 'selected' class from all regions */
function resetRegionsSelected () {
  document
    .querySelectorAll('.cmp-header__desktop__locations__continent__region')
    .forEach(function (region) {
      region.classList.remove('font-weight-bold')
    })
}

/* remove 'hovered' class from all menu items */
function resetHoverState () {
  document
    .querySelectorAll('.cmp-header__desktop .menu ul li button')
    .forEach(function (button) {
      button.classList.remove('hovered')
    })
}
export default cmpHeader
